import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { updateHeaderColor, updateMobileHeaderColor } from '../../utils/scroll';
import { isNull } from '../../utils/util';

import HeaderComponents from '../../components/Header/HeaderComponents';
import SideBannerComponents from '../../components/SideBanner/SideBannerComp';

import useInput from '../../hooks/useInput';

import { fetchBuyAcntData } from '../../services/buyService';
import { isMobile, SERVER_URL } from '../../config';

import S from './Support.module.css';

const BuyAcntPage = () => {
  
  const inputRef = useRef(null);
  const navigate = useNavigate();
  const [ searchParams ] = useSearchParams();

  const [ buy, setBuy ] = useState([]);
  const [ buyPwdCert, setBuyPwdCert ] = useState(false);
  const [ buyPwd, setBuyPwd ] = useInput({ pwd: ''});

  useEffect(() => {
    const wheelHandler = (e) => {
      if(isMobile()) {
        updateMobileHeaderColor();
      } else {
        updateHeaderColor();
      }
    };

    window.addEventListener('scroll', wheelHandler);

    return () => {
      window.removeEventListener('scroll', wheelHandler);
    };
  }, []);

  useEffect(() => {
    const idx = parseInt(searchParams.get('idx'));

    const buyPwdData = async () => {
        const buyAcntData = await fetchBuyAcntData(idx);

        if(isNull(buyAcntData[0].AC_PWD)) {
            setBuyPwdCert(true);
        } else {
            setBuyPwdCert(false);
        }
        setBuy(buyAcntData[0]);
    };
    
    buyPwdData();

  }, [searchParams] );

  useEffect(() => {
    inputRef.current.focus();
  }, []);

  const handelPwdSubmit = () => {

    if (buyPwd.pwd === buy.AC_PWD) {
        setBuyPwdCert(true);
        submitForm();
    } else {
        alert('틀린 비밀번호를 입력하였습니다.');
    }
  };

  const handlePreviousPage = () => {
    navigate('/support/buy');
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handelPwdSubmit();
    }
  };

  const submitForm = () => {

    const formatDate = () => {
        const date = new Date();
        const year = date.getFullYear();
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const day = ('0' + date.getDate()).slice(-2);
        const hours = ('0' + date.getHours()).slice(-2);
        const minutes = ('0' + date.getMinutes()).slice(-2);
        const seconds = ('0' + date.getSeconds()).slice(-2);
      
        return `${year}${month}${day}${hours}${minutes}${seconds}`;
    };

    const form = document.createElement('form');
    form.method = 'post';
    form.action = 'https://api.kiwoompay.co.kr/pay/link';
    form.acceptCharset = 'euc-kr';

    const fieldValues = {
        'TYPE': 'P',
        'PAYMETHOD': 'CARDK',
        'CPID': 'CMF15750',
        'ORDERNO': formatDate(),
        'PRODUCTTYPE': '2', // 상품구분(1: 디지털, 2: 실물)
        'AMOUNT': Math.floor(parseFloat(buy.AC_ACCOUNT)),
        'PRODUCTNAME': 'RFID 상품',
        'PRODUCTCODE': buy.AC_IDX,
        'USERID': buy.AC_DEPT_ID,
        'EMAIL': '',
        'USERNAME': buy.AC_DEPT_NAME,
        'RESERVEDINDEX1': '',
        'RESERVEDINDEX2': '',
        'RESERVEDSTRING': '',
        'BILLTYPE': '1',
        'TAXFREECD': '00', // 과세/비과세여부(00: 과세, 01: 비과세, 02: 복합과세)
        'TELNO2': '', // 비과세 대상금액(TAXFREECD가 02인 경우에만 필수전송)
        'DIRECTRESULTFLAG': 'N', // 키움페이 결제 완료 창 없이 HOMEURL로 바로 이동(Y/N)
        'HOMEURL': SERVER_URL + 'support/buy/success',  // 결제 성공 후, 이동할 URL(결제 창에서 이동)
        'CLOSEURL': SERVER_URL + 'support/buy/close', // 결제 창에서 취소 누를 시 이동할 URL (결제 창에서 이동)
        'FAILURL': SERVER_URL + 'support/buy/fail', // 결제 실패 후, 확인 버튼 입력 시 이동할 URL (결제 창에서 이동)
        'QUOTAOPT': '12',
    };
    
    Object.keys(fieldValues).forEach((name) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = fieldValues[name];
        form.appendChild(input);
    });
    
    const popupWindow = window.open('KIWOOMPAY', '_blank', 'width=468,height=750');
    if (popupWindow) {
        popupWindow.document.body.appendChild(form);
        form.submit();
    } else {
        alert('팝업 차단을 해제해주세요.');
    }
  };

  return (
    <div>
      <HeaderComponents pageKey="support" />
      <div className='sideBannerComp flex-coulum'>
        <div>
          <SideBannerComponents pageKey="support" />
        </div>
        <div className='com-content-wrap mt-200 mb-50'>
            {buyPwdCert ? (
                <div className={`flex-column mt-30 ${S.pwdDiv}`} draggable>
                    <div className={S.pwdTitle}>
                      결제가 <span className='rf-font'>진행중</span> 입니다.
                    </div>
                    <div className={`mt-30 ${S.subCont}`}>
                      잠시만 기다려 주십시오.
                    </div>
                    <div className={`mt-50 ${S.buyBtn}`} onClick={handlePreviousPage}>목록</div>
                </div>
            ):
            <div className='center' id={S.pwdInputWrap}>
                <input type='password' id='buyPwd' name='pwd' value={buyPwd.pwd} onChange={setBuyPwd} onKeyPress={handleKeyPress} ref={inputRef} className={S.iqPwdInput} placeholder='비밀번호를 입력하세요.'/>
                <div className='flex-row jt-con-between'>
                    <div className={S.iqBtn} onClick={handlePreviousPage}>목록</div>
                    <div className={`${S.iqBtn} ${S.wtFont}`} onClick={handelPwdSubmit}>입력</div>
                </div>
            </div>
            }
        </div>
      </div>
    </div>
  );
};

export default BuyAcntPage;
